var render = function () {
  var _vm$product, _vm$product$images, _vm$product2, _vm$product3, _vm$product4, _vm$product5, _vm$product6, _vm$product6$costPric, _vm$product6$costPric2, _vm$product7, _vm$product7$salePric, _vm$product7$salePric2, _vm$product$optionalP2, _vm$prevProduct, _vm$nextProduct, _vm$product8;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component",
    scopedSlots: _vm._u([{
      key: "fab",
      fn: function fn(_ref) {
        var _vm$product$optionalP;

        var showScroll = _ref.showScroll,
            scrollTo = _ref.scrollTo;
        return _vm.$vuetify.breakpoint.mobile && _vm.ready ? [_c('v-app-bar', {
          attrs: {
            "app": "",
            "bottom": "",
            "height": "auto",
            "color": "transparent",
            "elevation": "1"
          }
        }, [_c('v-responsive', {
          staticClass: "overflow-visible"
        }, [_c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: showScroll,
            expression: "showScroll"
          }],
          staticClass: "mt-n40px",
          attrs: {
            "fab": "",
            "absolute": "",
            "top": "",
            "right": "",
            "large": "",
            "tile": "",
            "color": "primary"
          },
          on: {
            "click": function click($event) {
              return scrollTo(0, 0);
            }
          }
        }, [_c('div', {
          staticClass: "pa-12px"
        }, [_c('v-icon', {
          staticClass: "my-n4px",
          attrs: {
            "size": "20"
          }
        }, [_vm._v("mdi-chevron-up")]), _c('div', {
          staticClass: "font-size-14 font-weight-medium mb-6px"
        }, [_vm._v("TOP")])], 1)]), _c('v-card', {
          attrs: {
            "elevation": "0"
          }
        }, [_c('v-divider'), _c('div', [_c('v-btn', {
          attrs: {
            "slot": "extension",
            "ripple": false,
            "block": "",
            "color": "grey lighten-4",
            "height": "28",
            "active-class": "no-active"
          },
          on: {
            "click": function click($event) {
              _vm.expand = !_vm.expand;
            }
          },
          slot: "extension"
        }, [_c('v-icon', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !_vm.expand,
            expression: "!expand"
          }],
          attrs: {
            "color": "grey"
          }
        }, [_vm._v("mdi-chevron-up")]), _c('v-icon', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.expand,
            expression: "expand"
          }],
          attrs: {
            "color": "grey"
          }
        }, [_vm._v("mdi-chevron-down")])], 1)], 1), _c('v-expand-transition', [_c('v-responsive', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.expand,
            expression: "expand"
          }],
          attrs: {
            "elevation": "0"
          }
        }, [_c('v-divider'), _c('div', {
          staticClass: "pa-12px py-md-14px"
        }, [(_vm$product$optionalP = _vm.product.optionalProducts) !== null && _vm$product$optionalP !== void 0 && _vm$product$optionalP.length ? [_c('optional-products', {
          attrs: {
            "product": _vm.product
          },
          model: {
            value: _vm.carts,
            callback: function callback($$v) {
              _vm.carts = $$v;
            },
            expression: "carts"
          }
        })] : _vm._e(), _vm.carts.length ? [_c('cart-list', {
          model: {
            value: _vm.carts,
            callback: function callback($$v) {
              _vm.carts = $$v;
            },
            expression: "carts"
          }
        })] : _vm._e(), _c('div', {
          staticClass: "mt-10px"
        }, [_c('v-row', {
          staticClass: "row--small font-size-14",
          attrs: {
            "align": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "3",
            "md": "2"
          }
        }, [_vm._v(" 총 합계 ")]), _c('v-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "9",
            "md": "10"
          }
        }, [_c('div', {
          staticClass: "d-inline-flex align-center font-size-20"
        }, [_c('b', {
          staticClass: "primary--text"
        }, [_vm._v(_vm._s(parseInt(_vm.totalAmount).format()))]), _c('span', {
          staticClass: "font-size-14 ml-2px"
        }, [_vm._v("원")])])])], 1)], 1)], 2), _c('v-divider')], 1)], 1), _c('div', {
          staticClass: "pa-12px py-md-14px"
        }, [_c('v-row', {
          staticClass: "row--x-small"
        }, [_c('v-col', [_c('v-btn', {
          attrs: {
            "x-large": "",
            "block": "",
            "color": "primary"
          },
          on: {
            "click": _vm.order
          }
        }, [_vm._v("구매하기")])], 1)], 1)], 1)], 1)], 1)], 1)] : undefined;
      }
    }], null, true)
  }, [_vm.ready ? [_vm.ready && _vm.product ? _c('v-card', {
    directives: [{
      name: "intersect",
      rawName: "v-intersect",
      value: {
        handler: _vm.onIntersect,
        options: {
          threshold: [0, 1.0]
        }
      },
      expression: "{ handler: onIntersect, options: { threshold: [0, 1.0] } }"
    }],
    staticClass: "contents-area",
    attrs: {
      "elevation": "0"
    }
  }, [_c('div', {
    staticClass: "mb-3"
  }, _vm._l(_vm.categories, function (category, index) {
    return _c('span', {
      key: category._id
    }, [_c('span', {
      class: index === _vm.categories.length - 1 ? 'font-weight-bold' : '',
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function click($event) {
          return _vm.go(category === null || category === void 0 ? void 0 : category._id);
        }
      }
    }, [_vm._v(" " + _vm._s(category.name) + " ")]), index !== _vm.categories.length - 1 ? _c('span', [_vm._v(" > ")]) : _vm._e()]);
  }), 0), _c('div', {
    staticClass: "contents-area__inner"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('v-card', {
    staticClass: "mb-md-4",
    attrs: {
      "outlined": "",
      "elevation": "0"
    }
  }, [_c('v-responsive', {
    staticClass: "mx-auto",
    attrs: {
      "width": "100%",
      "max-width": "480"
    }
  }, [_c('v-carousel', {
    attrs: {
      "height": "auto",
      "hide-delimiters": "",
      "show-arrows-on-hover": "",
      "show-arrows": 1 < ((_vm$product = _vm.product) === null || _vm$product === void 0 ? void 0 : (_vm$product$images = _vm$product.images) === null || _vm$product$images === void 0 ? void 0 : _vm$product$images.length)
    }
  }, _vm._l(((_vm$product2 = _vm.product) === null || _vm$product2 === void 0 ? void 0 : _vm$product2.images) || [], function (image, index) {
    return _c('v-carousel-item', {
      key: index
    }, [_c('v-img', {
      attrs: {
        "src": _vm.setImgSrc(image),
        "width": "100%",
        "max-width": "480",
        "contain": "",
        "aspect-ratio": 1 / 1
      }
    })], 1);
  }), 1)], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('div', {
    staticClass: "pl-md-10"
  }, [[_c('div', {
    staticClass: "tit-wrap mb-20px mb-md-30px"
  }, [_c('div', {
    staticClass: "tit tit--sm primary--text"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.product.name)
    }
  })])])], _c('v-divider'), _c('div', {
    staticClass: "py-10px py-md-16px"
  }, [[_c('product-info-field', {
    staticClass: "font-weight-medium",
    attrs: {
      "label": "판매가"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [(_vm$product3 = _vm.product) !== null && _vm$product3 !== void 0 && _vm$product3.costPrice && ((_vm$product4 = _vm.product) === null || _vm$product4 === void 0 ? void 0 : _vm$product4.costPrice) != ((_vm$product5 = _vm.product) === null || _vm$product5 === void 0 ? void 0 : _vm$product5.salePrice) ? _c('span', {
    staticClass: "font-size-14 line-height-1 text-decoration-line-through grey--text mr-8px"
  }, [_vm._v(_vm._s((_vm$product6 = _vm.product) === null || _vm$product6 === void 0 ? void 0 : (_vm$product6$costPric = _vm$product6.costPrice) === null || _vm$product6$costPric === void 0 ? void 0 : (_vm$product6$costPric2 = _vm$product6$costPric.format) === null || _vm$product6$costPric2 === void 0 ? void 0 : _vm$product6$costPric2.call(_vm$product6$costPric)) + "원")]) : _vm._e()]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "d-inline-flex align-center font-size-18 font-size-md-20 line-height-1"
  }, [_c('b', [_vm._v(_vm._s((_vm$product7 = _vm.product) === null || _vm$product7 === void 0 ? void 0 : (_vm$product7$salePric = _vm$product7.salePrice) === null || _vm$product7$salePric === void 0 ? void 0 : (_vm$product7$salePric2 = _vm$product7$salePric.format) === null || _vm$product7$salePric2 === void 0 ? void 0 : _vm$product7$salePric2.call(_vm$product7$salePric)))]), _c('span', {
    staticClass: "font-size-16 ml-2px"
  }, [_vm._v("원")])])])], 1)], 1)]], 2), _c('v-divider'), _c('div', {
    staticClass: "py-10px py-md-16px"
  }, [_vm._l(_vm.product.info, function (item, index) {
    return _c('product-info-field', {
      key: index,
      attrs: {
        "label": item.name
      }
    }, [item ? _c('span', [_c('b', [_vm._v(_vm._s(item.value))])]) : _vm._e()]);
  })], 2), !_vm.$vuetify.breakpoint.mobile && (_vm$product$optionalP2 = _vm.product.optionalProducts) !== null && _vm$product$optionalP2 !== void 0 && _vm$product$optionalP2.length && _vm.isSellable ? [_c('v-divider'), _c('div', {
    staticClass: "py-10px py-md-16px"
  }, [_c('optional-products', {
    attrs: {
      "product": _vm.product
    },
    model: {
      value: _vm.carts,
      callback: function callback($$v) {
        _vm.carts = $$v;
      },
      expression: "carts"
    }
  })], 1)] : _vm._e(), _vm.product.stock <= 0 || _vm.product.soldout ? [_c('v-divider'), _c('div', {
    staticClass: "py-10px py-md-16px"
  }, [_c('product-info-field', {
    staticClass: "mt-4 font-weight-bold",
    attrs: {
      "label": "수량"
    }
  }, [_vm._v("품절")])], 1)] : _vm._e(), _c('v-divider'), !_vm.$vuetify.breakpoint.mobile && _vm.carts.length ? [_c('div', {
    staticClass: "py-10px py-md-16px"
  }, [_c('cart-list', {
    model: {
      value: _vm.carts,
      callback: function callback($$v) {
        _vm.carts = $$v;
      },
      expression: "carts"
    }
  })], 1), _c('v-divider'), _c('div', {
    staticClass: "py-10px py-md-16px"
  }, [_c('v-row', {
    staticClass: "row--small font-size-14",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3",
      "md": "2"
    }
  }, [_vm._v(" 총 합계 ")]), _c('v-col', {
    attrs: {
      "cols": "9",
      "md": "10"
    }
  }, [_c('div', {
    staticClass: "d-inline-flex align-center font-size-18 font-size-md-24"
  }, [_c('b', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(parseInt(_vm.totalAmount).format()))]), _c('span', {
    staticClass: "font-size-16 ml-2px"
  }, [_vm._v("원")])])])], 1)], 1), _c('v-divider', {
    staticClass: "border-2"
  }), _c('div', {
    staticClass: "py-10px py-md-16px"
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "justify": "end",
      "align": "center"
    }
  }, [_c('v-col', [_c('v-btn', {
    attrs: {
      "block": "",
      "tile": "",
      "x-large": "",
      "color": "primary"
    },
    on: {
      "click": _vm.order
    }
  }, [_c('v-icon', {
    staticClass: "mr-10px"
  }, [_vm._v("mdi-shopping-outline")]), _vm._v("바로구매")], 1)], 1)], 1)], 1)] : _vm._e()], 2)])], 1), _c('v-divider', {
    staticClass: "d-none d-lg-block"
  }), _c('div', {
    staticClass: "pt-10px pt-md-16px"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "outlined": "",
      "color": "grey",
      "to": {
        path: "/dshop/".concat(_vm.path, "/").concat((_vm$prevProduct = _vm.prevProduct) === null || _vm$prevProduct === void 0 ? void 0 : _vm$prevProduct._id),
        query: _vm.$route.query
      },
      "disabled": !_vm.prevProduct
    }
  }, [_c('span', {
    staticClass: "d-flex align-center grey--text text--darken-3"
  }, [_c('v-icon', {
    staticClass: "mr-4px mr-md-10px",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-left")]), _vm._v("이전상품보기")], 1)])], 1), _c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "outlined": "",
      "color": "grey",
      "to": {
        path: "/dshop/".concat(_vm.path, "/").concat((_vm$nextProduct = _vm.nextProduct) === null || _vm$nextProduct === void 0 ? void 0 : _vm$nextProduct._id),
        query: _vm.$route.query
      },
      "disabled": !_vm.nextProduct
    }
  }, [_c('span', {
    staticClass: "d-flex align-center grey--text text--darken-3"
  }, [_vm._v("다음상품보기"), _c('v-icon', {
    staticClass: "ml-4px ml-md-10px",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-right")])], 1)])], 1)], 1)], 1)], 1)]) : _vm._e(), _c('v-divider'), _c('div', {
    staticClass: "overflow-hidden"
  }, [_c('div', {
    staticClass: "contents-area"
  }, [_c('div', {
    staticClass: "contents-area__inner"
  }, [_c('div', {
    staticClass: "mt-n60px pt-60px",
    attrs: {
      "id": "product-content"
    }
  }), _c('v-responsive', {
    directives: [{
      name: "intersect",
      rawName: "v-intersect",
      value: {
        handler: _vm.onDetails,
        options: {
          threshold: [0, 1.0]
        }
      },
      expression: "{ handler: onDetails, options: { threshold: [0, 1.0] } }"
    }],
    staticClass: "mb-10px"
  }, [_c('div', [_c('p', {
    domProps: {
      "innerHTML": _vm._s((_vm$product8 = _vm.product) === null || _vm$product8 === void 0 ? void 0 : _vm$product8.content)
    }
  })])])], 1)])])] : _vm._e(), _c('kcb-cert', {
    ref: "kcbCert"
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }